import { Check, Copy } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"

// A copyable artifact — an install snippet, a webhook URL, anything the user
// has to paste somewhere else. The full value shows in a well with the Copy
// button in its top-right corner, so the value is never truncated and the
// affordance sits in the same place every time it appears.
export function ArtifactBlock({ artifact }: { artifact: string }) {
  const [copied, setCopied] = useState(false)

  function copy() {
    void navigator.clipboard?.writeText(artifact)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <div className="bg-muted/60 flex items-start gap-2 rounded-md border p-2">
      <pre className="min-w-0 flex-1 py-1 text-xs leading-relaxed break-all whitespace-pre-wrap">
        {artifact}
      </pre>
      <Button
        variant="outline"
        size="sm"
        onClick={copy}
        className="bg-background h-7 shrink-0 px-2"
      >
        {copied ? (
          <Check className="size-3.5" />
        ) : (
          <Copy className="size-3.5" />
        )}
        {copied ? "Copied" : "Copy"}
      </Button>
    </div>
  )
}
